import {combineReducers} from "redux"
import rootData from "./reducer";
import pollData from "./pollsReducers";
import questionData from "./questionReducer";
import blogData from "./blogsReducer";
import resume from "./resume";
import resumeReducer from "./resumeReducer";

export default combineReducers({
    rootData,
    pollData,
    questionData,
    blogData,
    resume,
    resumeReducer
})
